import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  workflowId: '',
  waitForCompletion: true,
};

export default defaults;
